module.exports = __webpack_public_path__ + "static/media/table_bottom_arrow.ac374dd1.svg";